<template>
    <div :class="['ufo--page-hero-background', setCustomClass]" :style="setBackground">

        <div v-if="!!portfolioHero?.backgroundSettings.usingCustomBackground && portfolioHero?.backgroundSettings.selectedBackgroundStyleId > 0" class="background-wrapper">
            <InlineSvg
                v-for="(layer, i) in selectedBackgroundStyle.layers"
                :key="layer"
                class="background-svg"
                :src="layer"
                :style="[getSvgColor(i)]"
            />
        </div>
    </div>
</template>

<script>
import {EditedImageTypeEnum, SuggestedColorsEnum} from "../../../../common/enums.js";
    import InlineSvg from "vue-inline-svg";
    import bg_solid from "../../../../../images/background_generator/components/bg_solid.svg";
    import bg_gradient_3 from "../../../../../images/background_generator/components/bg_gradient_3.svg";
    import bg_gradient_4 from "../../../../../images/background_generator/components/bg_gradient_4.svg";
    import bg_gradient_5 from "../../../../../images/background_generator/components/bg_gradient_5.svg";
    import bg_gradient_6 from "../../../../../images/background_generator/components/bg_gradient_6.svg";
    import bg_gradient_7 from "../../../../../images/background_generator/components/bg_gradient_7.svg";
    import bg_gradient_8_a from "../../../../../images/background_generator/components/bg_gradient_8_a.svg";
    import bg_gradient_8_b from "../../../../../images/background_generator/components/bg_gradient_8_b.svg";
    import bg_gradient_9_a from "../../../../../images/background_generator/components/bg_gradient_9_a.svg";
    import bg_gradient_9_b from "../../../../../images/background_generator/components/bg_gradient_9_b.svg";
import {generateSuggestedColors, hexToRgba} from "../../../../common/helpers.js";
import {mapGetters} from "vuex";
import {resolveNonHexColor} from "@/scripts/common/utilities/colorUtils.js";

    export default {
        name: 'template-hero-background',
        components: {InlineSvg},
        data() {
            return {
                EditedImageTypeEnum: EditedImageTypeEnum,
                bgStyles: [
                    {
                        id: '0',
                        thumbnail: 'bg_style_1',
                        layers: [bg_solid],
                        type: 'none'
                    },
                    {
                        id: '1',
                        thumbnail: 'bg_style_2',
                        layers: [bg_solid],
                        type: 'solid'
                    },
                    {
                        id: '2',
                        thumbnail: 'bg_style_3',
                        layers: [bg_solid, bg_gradient_3],
                        type: 'gradient'
                    },
                    {
                        id: '3',
                        thumbnail: 'bg_style_4',
                        layers: [bg_solid, bg_gradient_4],
                        type: 'gradient'
                    },
                    {
                        id: '4',
                        thumbnail: 'bg_style_5',
                        layers: [bg_solid, bg_gradient_5],
                        type: 'gradient'
                    },
                    {
                        id: '5',
                        thumbnail: 'bg_style_6',
                        layers: [bg_solid, bg_gradient_6],
                        type: 'gradient'
                    },
                    {
                        id: '6',
                        thumbnail: 'bg_style_7',
                        layers: [bg_solid, bg_gradient_7],
                        type: 'gradient'
                    },
                    {
                        id: '7',
                        thumbnail: 'bg_style_8',
                        layers: [bg_solid, bg_gradient_8_a, bg_gradient_8_b],
                        type: 'gradient'
                    },
                    {
                        id: '8',
                        thumbnail: 'bg_style_9',
                        layers: [bg_solid, bg_gradient_9_a, bg_gradient_9_b],
                        type: 'gradient'
                    },
                ],
            }
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.modifySvgElements();
                }, 100); // Delay to allow time for SVGs to render
            });
        },
        computed: {
            ...mapGetters(["portfolioHero"]),
            ...mapGetters(
                "design",
                ["colorStyles", "colorPalette"]
            ),
            selectedBackgroundStyle() {
                return this.bgStyles.find(e => e.id === this.portfolioHero?.backgroundSettings?.selectedBackgroundStyleId);
            },
            setCustomClass() {
                return [this.showOverlay ? 'overlay' : null, this.showBlur ? 'blur' : null].toString().replace(',', ' ');
            },
            showOverlay() {
                return !!this.portfolioHero?.overlaySettings.overlay && this.portfolioHero?.overlaySettings.overlay.a > 0 && !this.portfolioHero?.backgroundSettings.usingCustomBackground;
            },
            showBlur() {
                return !!this.portfolioHero?.overlaySettings.blur && !this.portfolioHero?.backgroundSettings.usingCustomBackground;
            },
            setDim() {
                if(!!this.portfolioHero?.overlaySettings.overlay) {
                    let rgbaColor = `rgba(${this.portfolioHero?.overlaySettings.overlay.r}, ${this.portfolioHero?.overlaySettings.overlay.g}, ${this.portfolioHero?.overlaySettings.overlay.b}, ${this.portfolioHero?.overlaySettings.overlay.a})`

                    if(this.portfolioHero?.overlaySettings.overlay.paletteColorIndex !== null && this.portfolioHero?.overlaySettings.overlay.paletteColorIndex !== undefined) {
                        rgbaColor = hexToRgba(this.colorPalette.colors[this.portfolioHero?.overlaySettings.overlay.paletteColorIndex], this.portfolioHero?.overlaySettings.overlay.a)
                    }

                    return rgbaColor
                }
                return null;
            },
            setBlur() {
                if(!!this.portfolioHero?.overlaySettings.blur && !this.portfolioHero?.backgroundSettings.usingCustomBackground) {
                    return `${this.portfolioHero?.overlaySettings.blur}px`
                }
            },
            backgroundImageUrl() {
                if(!!this.portfolioHero.image && !this.portfolioHero.usingCustomBackground) {
                    return !!this.portfolioHero.image.croppedImageUrl
                        ? this.portfolioHero.image.croppedImageUrl
                        : this.portfolioHero.image.url
                }
            },
            backgroundColor() {
                return !!this.portfolioHero?.backgroundSettings.backgroundColor
                    ? this.portfolioHero?.backgroundSettings.backgroundColor.startsWith("#")
                        ? this.portfolioHero?.backgroundSettings.backgroundColor
                        : `#${this.portfolioHero?.backgroundSettings.backgroundColor}`
                    : null
            },
            setBackground() {
                return {
                    'background-image': !!this.backgroundImageUrl ? `url(${this.backgroundImageUrl})` : null,
                    '--colorOverlay': this.setDim,
                    '--blur': this.setBlur
                }
            },
            suggestedColorsUsed() {
                return this.portfolioHero?.backgroundSettings.backgroundColor && !this.portfolioHero?.backgroundSettings.backgroundColor.startsWith('#') && Object.values(SuggestedColorsEnum).includes(this.portfolioHero?.backgroundSettings.backgroundColor)
            },
            suggestedColorOptions() {
                return generateSuggestedColors(this.colorStyles, this.colorPalette)
            },
        },
        methods: {
            // This beauty is used to generate unique ids for the svg-s, that are using 'linearGradient'
            // to fix the issue of inheriting 'color' based on 'id' in the DOM causing every svg
            // to have the same color that was set on the first svg file with that 'id'
            modifySvgElements() {
                this.$nextTick(() => {
                    const svgElements = this.$el.querySelectorAll('svg');

                    svgElements.forEach((svg, index) => {
                        const uniqueId = `gradient-portfolio-hero-${index}`;

                        const gradients = svg.querySelectorAll('linearGradient');
                        gradients.forEach((gradient) => {
                            const oldId = gradient.id;
                            const newId = `${uniqueId}-${oldId}`;
                            gradient.id = newId;

                            const references = svg.querySelectorAll(`[fill="url(#${oldId})"], [stroke="url(#${oldId})"]`);
                            references.forEach((ref) => {
                                ref.setAttribute('fill', `url(#${newId})`);
                                ref.setAttribute('stroke', `url(#${newId})`);
                            });
                        });
                    });
                });
            },
            getSvgColor(svgIndex) {
                const { suggestedColorsUsed, selectedBackgroundStyle, portfolioHero, suggestedColorOptions } = this;

                if(this.portfolioHero.selectedBackgroundStyleId === null && this.portfolioHero?.backgroundSettings.backgroundColor) {
                    return this.setBackground;
                }

                if (suggestedColorsUsed) {
                    const colorOptions = suggestedColorOptions[selectedBackgroundStyle.type][portfolioHero?.backgroundSettings.backgroundColor];
                    return { color: svgIndex === 0 ? colorOptions[0] : colorOptions[1] };
                }

                if (svgIndex === 0) return { color: resolveNonHexColor(portfolioHero?.backgroundSettings.backgroundColor, this.colorPalette)  };
                if (svgIndex === 1) return { color: resolveNonHexColor(portfolioHero?.backgroundSettings.gradientColor1, this.colorPalette) };
                // TODO designer ignored my request, so I changed gradientColor2 to gradientColor1 here
                return { color: resolveNonHexColor(portfolioHero?.backgroundSettings.gradientColor1, this.colorPalette) };
            }
        }
    }
</script>

<style lang="scss" scoped>
    .ufo--page-hero-background {
        overflow: hidden;
    }

    .background-wrapper {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        .background-svg {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
        }
    }

    .theme_six,
    .profile_theme_six {
        .ufo--page-hero-background {
            .ufo-fab--container {
                top: -28px;
            }
        }
    }

    .theme_five,
    .profile_theme_five {
        .ufo--page-hero-background {
            .ufo-fab--container {
                top: 74px;
            }
        }
    }
</style>
